export const sizes = {
    borderRadius: 4,
    input: {
        height: 36,
        paddingX: 10,
        paddingY: 6,
        borderRadius: 4,
    },

    dropdown: {
        height: 350,//for doropdown menu
        paddingX: 8,
        paddingY: 6
    },

    button: {
        height: 48,
        small: 36,
        medium: 48,
        large: 56,
        paddingX: 8,
        paddingY: 6,
        padding: 8 // general padding for contained buttons
    },

    icon: {
        xsmall: 16, // inline glyph sitting beside text (tab labels, chips)
        small: 18,
        medium: 22,
        large: 26
    },

    table: {
        rowHeight: 36,
        headerHeight: 40,
        paddingX: 8,
        paddingY: 6
    }

};